export const APARTMENT_PLACEHOLDER_IMAGE_URL =
  "https://t3.ftcdn.net/jpg/01/05/82/76/360_F_105827660_Gifynz6B7PPcOvPsjW54zUMZI6G1VWlc.jpg";
